
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-sg-payment-options-trigger]');
  if ( trigger ) {
    const modal = document.getElementById(trigger.dataset.modalId);
    if ( modal && typeof modal.show === 'function' ) {
      event.preventDefault();
      window.lastFocusedElm = trigger;
      modal.show();
    }
    return;
  }

  const checkoutButton = event.target.closest('[data-sg-payment-options-checkout]');
  if ( ! checkoutButton ) return;

  const form = document.getElementById(checkoutButton.dataset.formId);
  if ( ! form ) return;

  if ( ! form.checkValidity() ) {
    form.reportValidity();
    return;
  }

  let returnTo = form.querySelector('input[name="return_to"]');
  if ( ! returnTo ) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    form.appendChild(returnTo);
  }
  returnTo.value = '/checkout';
  form.submit();
});

